import jwtDecode from "jwt-decode";
import { JwtOptions } from "@/interfaces/jwt/jwt-options";
import { JwtPayload } from "@/interfaces/jwt/jwt-payload";
import { JwtHeader } from "@/interfaces/jwt/jwt-header";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * JWT Service
 */
export class JwtService {
  constructor(private jwtOptions: JwtOptions) {}

  /** Returns decoded JWT header */
  get header(): JwtHeader {
    return jwtDecode(this.tokenString, {
      header: true
    });
  }

  /** Returns decoded JWT payload */
  get payload(): JwtPayload {
    return jwtDecode(this.tokenString);
  }

  /** Returns information whether JWT is valid */
  get isTokenValid(): boolean {
    try {
      return !!this.payload;
    } catch {
      return false;
    }
  }

  /** Returns information whether JWT is expired */
  get isTokenExpired(): boolean {
    return this.payload.exp < Math.floor(Date.now() / 1000);
  }

  /** Returns token as string from token getter */
  get tokenString(): string {
    return this.jwtOptions.tokenGetter() as string;
  }
}
